import React from 'react';
import styled from 'styled-components';
import SpinnerTwo from '@ad-scripts/presentation/components/common/spinner_two';
import theme from '@ad-scripts/presentation/themes/default';

export const Spinner = () => (
  <SpinnerContainer data-aid="loading-spinner">
    <SpinnerTwo color={theme.colors.gray400} size={48} stroke={3} />
  </SpinnerContainer>
);

const SpinnerContainer = styled.span`
  align-items: center;
  display: flex;
  flex: 1 1 300px;
  justify-content: center;
  width: 100%;
`;
